import React from 'react'
import cx from 'classnames'
import * as R from 'ramda'

import { Icon, AlertOctagonIcon } from 'components/shared/Icon/Icon'

import styles from './FormFieldError.module.scss'

export const FormFieldError = ({ className = undefined, error }) => {
  if (R.not(error)) {
    return null
  }

  return (
    <p className={cx(styles.error, { [className]: Boolean(className) })}>
      <Icon className={styles.icon} icon={AlertOctagonIcon} size={16} />
      <span className={styles.text}>{error}</span>
    </p>
  )
}
